import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Button,
  Modal,
  message,
  Spin,
  Divider,
  Tag,
  Space,
  Typography,
  Table,
  Descriptions,
  Popconfirm,
  Card,
  Row,
  Col,
  Collapse,
} from "antd";
import {
  FileTextOutlined,
  BankOutlined,
  CalendarOutlined,
  SaveOutlined,
  InfoCircleOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
  CommentOutlined,
} from "@ant-design/icons";
import { faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";

import {
  HEADERS_EXPORT_BEN,
  POST_BILL_PAYMENT,
  POST_LOAD_DETAIL_OLD_DATA,
  POST_LOAN_DB2,
  POST_CEO_RECHECK_COMPLETE_JUDGE_DOC,
  POST_LOAD_MEMO_NEW,
  HEADERS_EXPORT,
} from "../../../API/apiUrls";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import TokenCheck from "../../../../hook/TokenCheck";

const { Text } = Typography;

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// ========================================
// Main Component
// ========================================
const CeoReview = ({ open, close, dataDefault, func, process }) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const [signOut] = TokenCheck();
  // States
  const [loading, setLoading] = useState(false);
  const [judgeData, setJudgeData] = useState(null);
  const [lawsuitData, setLawsuitData] = useState(null);
  const [dataAsset, setDataAsset] = useState([]);
  const [arothrData, setArothrData] = useState([]);
  const [dataDB2, setDataDB2] = useState(null);
  const [billPayment, setBillPayment] = useState(null);
  const [isModalpayIn, setIsModalPayIn] = useState(false);
  const [isModalProductTranfer, setIsModalProductTranfer] = useState(false);
  const [isModalProductTranferAccount, setIsModalProductTranferAccount] =
    useState(false);
  const [oldMemo, setOldMemo] = useState();
  const [showNote, setShowNote] = useState();

  // ========================================
  // AROTHR Options for display
  // ========================================
  const arothrOptions = useMemo(
    () => [
      { value: "111", label: "ค่าติดตาม" },
      { value: "222", label: "ค่าทนาย" },
      { value: "333", label: "ค่าธรรมเนียม" },
      { value: "444", label: "ค่าใช้จ่ายอื่นๆ" },
    ],
    [],
  );

  // ========================================
  // Load Main Data
  // ========================================
  const loadData = useCallback(async () => {
    if (!dataDefault?.lawsuitId) return;
    console.log("dataDefault?.CONTNO_DB2", dataDefault?.CONTNO_DB2);

    setLoading(true);
    try {
      const [loadDetailOldData, loadDataDB2, loadBillPayment, loadOldMemo] =
        await Promise.all([
          axios.post(
            POST_LOAD_DETAIL_OLD_DATA,
            {
              CONTNO: dataDefault.newContno,
              loanId: dataDefault.loanId,
              lawsuitId: dataDefault.lawsuitId,
            },
            { headers: HEADERS_EXPORT_BEN },
          ),
          axios
            .post(
              POST_LOAN_DB2,
              {
                CONTNO: `'${dataDefault?.CONTNO_DB2}'`,
              },
              { headers: HEADERS_EXPORT_BEN },
            )
            .catch((err) => {
              console.warn("⚠️ load db2 failed:", err?.response?.data || err);
              return null;
            }),
          axios.post(
            POST_BILL_PAYMENT,
            {
              CONTNO: dataDefault.newContno || "V" + dataDefault.CONTNO,
            },
            { headers: HEADERS_EXPORT_BEN },
          ),
          axios
            .post(POST_LOAD_MEMO_NEW, {
              contractNo: dataDefault?.CONTNO_DB2,
            })
            .catch((err) => {
              // memo ไม่ใช่ข้อมูลหลัก ถ้าโหลดไม่ได้ให้ทำงานต่อ
              console.warn("⚠️ load memo failed:", err?.response?.data || err);
              return null;
            }),
        ]);
      console.log("✅ loadDetailOldData:", loadDetailOldData?.data);
      if (loadDetailOldData?.data) {
        console.log("✅ loadDetailOldData:", loadDetailOldData?.data);
        const { judge, lawsult, arothr, asset } = loadDetailOldData?.data;
        setShowNote(asset?.length > 0 ? false : true);
        setJudgeData(judge || null);
        setLawsuitData(lawsult || null);
        setArothrData(arothr || []);
        setDataAsset(asset);
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }
      console.log("loadDataDB2", loadDataDB2);

      if (loadDataDB2?.data) {
        console.log("✅ loadDataDB2:", loadDataDB2?.data[0]);
        setDataDB2(loadDataDB2?.data[0] || null);
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }
      if (loadBillPayment?.data) {
        console.log("✅ loadBillPayment:", loadBillPayment?.data);
        setBillPayment(loadBillPayment?.data);
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }
      console.log("loadOldMemo.data?.MEMO1", loadOldMemo?.data?.MEMO1);

      if (loadOldMemo?.data?.MEMO1) {
        setOldMemo(loadOldMemo?.data?.MEMO1);
      }
    } catch (error) {
      console.error("❌ Error loading data:", error);
      if (
        error?.response?.data === "Session expired" ||
        error?.response?.data === "Invalid Token"
      ) {
        signOut();
      } else {
        message.error(
          error?.response?.data?.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล",
        );
      }
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);

  useEffect(() => {
    if (open) {
      loadData();
    }
  }, [open, loadData]);

  const handleSave = async (status) => {
    setLoading(true);
    try {
      console.log("status", status);

      const payload = {
        judge: judgeData,
        currentStatus: status,
        userId: userId,
      };

      console.log("📌 Payload ส่ง API:", payload);

      const result = await postApprovStatus(payload);

      if (func) {
        func({
          action: "refresh",
          data: result,
          process: process,
        });
      }

      message.success("บันทึกสำเร็จ");
      close();
    } catch (err) {
      console.error("❌ Error saving:", err);
      message.error(
        status === 3 || status === 6 ? "แก้ไขไม่สำเร็จ" : "บันทึกไม่สำเร็จ",
      );
    } finally {
      setLoading(false);
    }
  };

  // ✅ ฟังก์ชันส่งข้อมูลไป API
  const postApprovStatus = async (payload) => {
    console.log("📤 POST_DOC_STATUS with data:", payload);

    try {
      const res = await axios.post(
        POST_CEO_RECHECK_COMPLETE_JUDGE_DOC,
        payload,
        {
          headers: HEADERS_EXPORT_BEN,
        },
      );

      const { status, data } = res;

      if (status === 200) {
        console.log("✅ API Response:", data);
        return data;
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 400) {
        message.error(`ข้อมูลไม่ถูกต้อง: ${serverMsg}`);
      } else if (status === 500) {
        message.error("เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (500)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }

      console.error("❌ postDocStatus error:", error);
      throw error;
    }
  };

  // ========================================
  // Handle Cancel
  // ========================================
  const handleCancel = useCallback(() => {
    setJudgeData(null);
    setLawsuitData(null);
    setArothrData([]);
    close(false);
  }, [close]);

  // ========================================
  // Render Judge Info
  // ========================================
  const renderJudgeInfo = useMemo(() => {
    if (!judgeData) return null;

    const { judgeDef, loanNew } = judgeData;

    const defendantColumns = [
      {
        title: "จำเลยที่",
        dataIndex: "defendantNumber",
        key: "defendantNumber",
        width: 80,
        align: "center",
        render: (val) => <Tag color="blue">{val}</Tag>,
      },
      {
        title: "รหัสลูกค้า",
        dataIndex: "customerId",
        key: "customerId",
        render: (val) => <Text style={{ fontFamily: "monospace" }}>{val}</Text>,
      },
      {
        title: "ยอดคงเหลือ",
        dataIndex: "TONBALANCE",
        key: "TONBALANCE",
        align: "right",
        render: (val) => <Text>{currencyFormatPoint(val)} บาท</Text>,
      },
      {
        title: "อัตราดอกเบี้ย",
        dataIndex: "interestRate",
        key: "interestRate",
        align: "center",
        render: (val) => <Text>{val || 0}%</Text>,
      },
      {
        title: "ค่าขาดประโยชน์",
        dataIndex: "costOfUselessness",
        key: "costOfUselessness",
        align: "right",
        render: (val) => <Text>{currencyFormatPoint(val)} บาท</Text>,
      },
      {
        title: "วันที่สร้าง",
        dataIndex: "CreatedAt",
        key: "CreatedAt",
        render: (val) => formatDate(val),
      },
    ];

    const FLAG_CONFIG = {
      1: {
        background: "#f6ffed",
        border: "1px solid #b7eb8f",
        label: "ทำยอม",
        badgeColor: "#389e0d",
        badgeBg: "#d9f7be",
      },
      2: {
        background: "#fff2f0",
        border: "1px solid #ffccc7",
        label: "พิพากษา",
        badgeColor: "#cf1322",
        badgeBg: "#ffebe8",
      },
      6: {
        background: "#fff2f0",
        border: "1px solid #ffccc7",
        label: "(ส่วนต่าง)",
        badgeColor: "#cf1322",
        badgeBg: "#ffebe8",
      },
    };

    const flagStyle = FLAG_CONFIG[dataDefault.flagLoanNew] ?? FLAG_CONFIG[1];
    const lawStyle = dataDefault.LAW_TYPE_ID === 6 && FLAG_CONFIG[6];

    const interestText = (rate) =>
      parseInt(rate) ? (
        <span style={{ fontSize: 14, color: "#888" }}> ดอกเบี้ย {rate}%</span>
      ) : null;

    const totalJudge = parseFloat(judgeData.totalJugde || 0);
    const creditOld = parseFloat(judgeData.creditDebtorOld || 0);
    const creditOld10 = creditOld * 0.1;

    const creditAll = Math.round(creditOld + creditOld10);
    const diff = totalJudge - creditAll;
    const isProfit = diff > 0;

    return (
      <>
        <Divider orientation="left">
          <Space size={6}>
            <BankOutlined />
            ข้อมูลคำพิพากษา
            <span
              style={{
                background: flagStyle.badgeBg,
                color: flagStyle.badgeColor,
                borderRadius: 20,
                padding: "2px 10px",
                fontSize: 20,
                fontWeight: 500,
              }}
            >
              {flagStyle.label}
              {lawStyle.label}
            </span>
          </Space>
        </Divider>

        <div
          style={{
            background: flagStyle.background,
            border: flagStyle.border,
            borderRadius: 10,
            padding: "18px",
            marginBottom: 16,
          }}
        >
          <Descriptions
            bordered
            size="meduim"
            column={{ xs: 1, sm: 2, md: 3 }}
            label={{ fontSize: 16 }}
            style={{ fontSize: 15 }}
          >
            <Descriptions.Item label="เลขคดีดำ">
              <Text strong copyable>
                {lawsuitData.blackCaseNumber || "-"}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="เลขคดีแดง">
              <Text strong copyable>
                {judgeData.redCaseNumber || "-"}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="วันพิพากษา">
              {formatDate(judgeData.judgeDate)}
            </Descriptions.Item>

            <Descriptions.Item label="ค่าชดใช้แทน">
              <Text strong style={{ color: "#cf1322", fontSize: "15px" }}>
                {currencyFormatPoint(judgeData.judgement)} บาท
                <br />
                {interestText(judgeData.judgeInterestRate)}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ต้นเงิน">
              {currencyFormatPoint(judgeData.judgementLack)} บาท
              <br />
              {interestText(judgeData.interestRate)}
            </Descriptions.Item>
            <Descriptions.Item label="ดอกเบี้ยก่อนฟ้อง">
              {currencyFormatPoint(judgeData.judgementInterest)} บาท
            </Descriptions.Item>

            <Descriptions.Item label="ค่าขาดประโยชน์">
              {currencyFormatPoint(judgeData.lackOfBenefits)} บาท
              <br />
              {interestText(judgeData.interestRateOfLack)}
            </Descriptions.Item>
            <Descriptions.Item label="ค่าขาดประโยชน์รายเดือน">
              {currencyFormatPoint(
                judgeData?.judgeDef[0]?.costOfUselesenessPerMonth,
              )}{" "}
              บาท
            </Descriptions.Item>
            <Descriptions.Item label="ระยะเวลาขาดประโยชน์">
              {currencyFormatPoint(
                judgeData?.judgeDef[0]?.costOfUselesenessMonth,
              )}{" "}
              เดือน
            </Descriptions.Item>

            <Descriptions.Item label="ค่าทนาย">
              {currencyFormatPoint(judgeData.attorneyFees)} บาท
            </Descriptions.Item>
            <Descriptions.Item label="ค่าติดตาม">
              {currencyFormatPoint(judgeData.trackingFee)} บาท
            </Descriptions.Item>
            <Descriptions.Item label="ค่าธรรมเนียมศาล">
              {currencyFormatPoint(judgeData.fee)} บาท
            </Descriptions.Item>
          </Descriptions>
          <Text style={{ fontSize: 16, margin: 10 }}>
            <span style={{ color: "#888" }}>ผู้รับผิดชอบ: </span>
            <span style={{ fontWeight: 500 }}>
              {lawsuitData?.FNAME} {lawsuitData?.LNAME}
            </span>
            <span style={{ fontWeight: 500, marginLeft: 6 }}>
              ({lawsuitData?.NNAME})
            </span>
          </Text>

          {/* Summary */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 5,
              padding: "10px 14px",
              background: "rgba(0,0,0,0.03)",
              borderRadius: 8,
            }}
          >
            <Text style={{ color: "#888", fontSize: 16 }}>
              ศาลคิดให้ {` (${currencyFormatPoint(totalJudge)})`} −
              ต้นทุนเก่า(+10%) {currencyFormatPoint(creditAll)}
            </Text>
            <Text
              strong
              style={{ fontSize: 15, color: isProfit ? "green" : "red" }}
            >
              {isProfit ? "(กำไร)" : "(ขาดทุน)"}{" "}
            </Text>
            <Text
              strong
              style={{ color: isProfit ? "green" : "red", fontSize: 15 }}
            >
              {currencyFormatPoint(diff)} บาท
            </Text>
          </div>
        </div>

        {/* loanNew */}
        {loanNew && (
          <>
            <Divider orientation="left">
              <Space size={6}>
                <CalendarOutlined /> ข้อมูลสัญญาใหม่
                <span
                  style={{
                    background: flagStyle.badgeBg,
                    color: flagStyle.badgeColor,
                    borderRadius: 20,
                    padding: "2px 10px",
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  {flagStyle.label}
                </span>
              </Space>
            </Divider>
            <div
              style={{
                background: "#e6f7ff",
                border: "1px solid #91d5ff",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "16px",
              }}
            >
              <Descriptions
                bordered
                size="meduim"
                column={{ xs: 1, sm: 2, md: 3 }}
              >
                <Descriptions.Item label="เลขสัญญาเดิม">
                  <Text copyable>{loanNew.ISSUNO || "-"}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="วันทำสัญญา">
                  {formatDate(loanNew.SDATE)}
                </Descriptions.Item>
                <Descriptions.Item label="งวดแรก">
                  {formatDate(loanNew.FDATE)}
                </Descriptions.Item>
                <Descriptions.Item label="งวดสุดท้าย">
                  {formatDate(loanNew.LDATE)}
                </Descriptions.Item>
                <Descriptions.Item label="จำนวนงวด">
                  <Tag color="blue">{loanNew.T_NOPAY} งวด</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="ค่างวด">
                  <Text strong style={{ color: "#1890ff" }}>
                    {currencyFormatPoint(loanNew.TOT_UPAY)} บาท
                  </Text>
                </Descriptions.Item>

                <Descriptions.Item label="ยอดคงเหลือ">
                  <Text strong style={{ color: "#fa541c" }}>
                    {currencyFormatPoint(loanNew.LOAN_NEW_TONBALANCE)} บาท
                  </Text>
                </Descriptions.Item>
              </Descriptions>
            </div>
          </>
        )}
      </>
    );
  }, [judgeData, arothrData, arothrOptions]);

  const renderDetailLoan = useMemo(() => {
    const assetItems = dataAsset?.map((person, index) => {
      const hasAsset = person.assetLand && person.assetLand.length > 0;
      const activeAssets = person.assetLand?.filter((a) => a.active) || [];
      const assetColumns = [
        {
          title: "ประเภททรัพย์",
          dataIndex: "typeLand",
          key: "typeLand",
          width: 120,
          render: (type) => {
            const typeMap = {
              1: "โฉนด",
              2: "นส.3ก.",
              3: "ห้องชุด",
              4: "อาคารชุด",
              5: "นภ.1",
              6: "อื่น ๆ",
            };
            return typeMap[type] || "-";
          },
        },
        {
          title: "เลขที่ดิน",
          dataIndex: "numberLand",
          key: "numberLand",
          width: 150,
        },
        {
          title: "จังหวัด",
          dataIndex: "provDesc",
          key: "provDesc",
          width: 150,
        },
        {
          title: "อำเภอ",
          dataIndex: "distDesc",
          key: "distDesc",
          width: 150,
        },
        {
          title: "ตำบล",
          dataIndex: "subDistDesc",
          key: "subDistDesc",
          width: 150,
        },
      ];

      return {
        key: String(index),
        label: (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span>
              <strong>
                {person.SNAM}
                {person.NAME1} {person.NAME2}
              </strong>
              {person.garno > 0 && (
                <Tag color="orange" style={{ marginLeft: 8 }}>
                  {person.relation || `คนค้ำที่ ${person.garno}`}
                </Tag>
              )}
              {person.garno === 0 && (
                <Tag color="blue" style={{ marginLeft: 8 }}>
                  {person.relation || "ผู้เช่าซื้อ"}
                </Tag>
              )}
            </span>
            <span>
              <Tag color={hasAsset ? "green" : "red"}>
                {hasAsset
                  ? `พบทรัพย์ ${activeAssets?.length} รายการ`
                  : "ไม่พบทรัพย์"}
              </Tag>
            </span>
          </div>
        ),
        children: (
          <div>
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={8}>
                <strong>เลขบัตร:</strong> {person.CUSCOD || "-"}
              </Col>
              <Col span={8}>
                <strong>ความสัมพันธ์:</strong> {person.relation || "-"}
              </Col>
            </Row>

            {hasAsset ? (
              <>
                <Divider orientation="left" style={{ margin: "12px 0" }}>
                  รายการทรัพย์สิน
                </Divider>
                <Table
                  dataSource={person.assetLand}
                  columns={assetColumns}
                  rowKey="landId"
                  pagination={false}
                  size="small"
                  bordered
                  scroll={{ x: 800 }}
                />
              </>
            ) : (
              <div
                style={{ textAlign: "center", padding: "20px", color: "#999" }}
              >
                ไม่มีข้อมูลทรัพย์สิน
              </div>
            )}
          </div>
        ),
      };
    });

    return (
      <>
        <Divider orientation="left">
          <FontAwesomeIcon icon={faMapLocationDot} /> รายละเอียดทรัพย์
        </Divider>
        {dataAsset?.length > 0 ? (
          <Collapse items={assetItems} style={{ marginBottom: 16 }} />
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "20px",
              border: "1px solid #e8e8e8",
              borderRadius: "8px",
              marginBottom: 16,
              color: "#999",
            }}
          >
            ไม่มีข้อมูลทรัพย์สิน
          </div>
        )}
      </>
    );
  }, [dataAsset]);

  return (
    <>
      <Modal
        title={
          <Space>
            <FileTextOutlined />
            <span>
              รายละเอียดสัญญา -{" "}
              <Text copyable={{ text: dataDefault?.CONTNO }}>
                {judgeData?.newContno || dataDefault?.CONTNO}
              </Text>
            </span>
          </Space>
        }
        open={open}
        onCancel={handleCancel}
        width={1200}
        footer={null}
        destroyOnHidden
      >
        <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
          {renderJudgeInfo}
          {renderDetailLoan}
          <div
            onClick={() => setShowNote((prev) => !prev)}
            style={{ cursor: "pointer", userSelect: "none" }}
          >
            <Divider orientation="left" style={{ marginBottom: 0 }}>
              <Space>
                <Typography.Text strong>
                  <CommentOutlined /> หมายเหตุโปรแกรมภายใน(ล็อคหน้าจอ)
                </Typography.Text>
                <Tag
                  color={showNote ? "blue" : "default"}
                  style={{ marginInlineEnd: 0 }}
                >
                  {showNote ? <UpSquareOutlined /> : <DownSquareOutlined />}
                </Tag>
              </Space>
            </Divider>
          </div>

          {showNote && (
            <Card
              size="small"
              style={{
                marginTop: 8,
                borderRadius: 8,
                background: "#fffbe6",
                borderColor: "#ffe58f",
              }}
              styles={{ body: { padding: "10px 16px" } }}
            >
              <Space align="start">
                <InfoCircleOutlined
                  style={{ color: "#faad14", marginTop: 2 }}
                />
                <Typography.Text
                  style={{ color: "#614700", whiteSpace: "pre-wrap" }}
                >
                  {oldMemo || "-"}
                </Typography.Text>
              </Space>
            </Card>
          )}

          <div style={{ textAlign: "center", marginTop: 24 }}>
            <Space size="large">
              <Button
                onClick={handleCancel}
                size="large"
                danger
                style={{ minWidth: 120, borderRadius: 8 }}
              >
                ปิด
              </Button>
              {dataDefault.currentStatus === 17 && (
                <>
                  <Popconfirm
                    placement="topLeft"
                    title="อัพเดทสถานะส่งอุธรณ์"
                    description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                    onConfirm={() => handleSave(13)}
                    onCancel={() => message.info("ยกเลิกการส่งอุธรณ์")}
                    okText="ยืนยัน"
                    cancelText="ยกเลิก"
                    okButtonProps={{ size: "large" }}
                    cancelButtonProps={{ size: "large" }}
                  >
                    <Button
                      color="orange"
                      variant="outlined"
                      size="large"
                      style={{ minWidth: 120 }}
                      icon={"⚖️"}
                      disabled={
                        loading ||
                        dataDefault.flagLoanNew === 1 ||
                        judgeData?.totalJugde >
                          judgeData?.creditDebtorOld +
                            Math.round(judgeData?.creditDebtorOld * 0.1)
                      }
                      // onClick={() => handleSave(13)}
                    >
                      ส่งอุธรณ์
                    </Button>
                  </Popconfirm>
                  <Popconfirm
                    placement="topLeft"
                    title="อัพเดทสถานะอนุมัติ"
                    description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                    onConfirm={() => handleSave(18)}
                    onCancel={() => message.info("ยกเลิกการอนุมัติ")}
                    okText="ยืนยัน"
                    cancelText="ยกเลิก"
                    okButtonProps={{ size: "large" }}
                    cancelButtonProps={{ size: "large" }}
                  >
                    <Button
                      color="blue"
                      variant="outlined"
                      size="large"
                      icon={<SaveOutlined />}
                      style={{ minWidth: 120 }}
                      // onClick={() => handleSave(18)}
                      disabled={loading}
                    >
                      อนุมัติ
                    </Button>
                  </Popconfirm>
                </>
              )}
            </Space>
          </div>
        </Spin>
      </Modal>
    </>
  );
};

export default CeoReview;
